import { Box } from "@mui/material";
import React from "react";
// import BasicTab from "./BasicTab";
import { Outlet } from "react-router-dom";

export default function Admin() {
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);

  const isAdmin = data.isAdmin;

  return (
    isAdmin && (
      <Box>
        {/* <BasicTab /> */}
        <Outlet />
      </Box>
    )
  );
}
